import React from 'react';

/**
 * Shared milestone flag — HUD, canvas nodes, minimap.
 * Simple rectangular flag on a pole.
 */
export function MilestoneFlagIcon({
  size = 16,
  className = '',
  reached = false,
  color,
}) {
  const fill = color ?? (reached ? '#86efac' : '#a78bfa');

  return (
    <svg
      className={`milestone-flag-icon ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      {/* Pole */}
      <rect x="5" y="3" width="2.5" height="18" rx="1.25" fill={fill} />
      {/* Rectangle flag */}
      <rect x="7.5" y="3" width="12.5" height="9" rx="1" fill={fill} />
    </svg>
  );
}

export default MilestoneFlagIcon;
